import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISettingsState } from '../interfaces/setting-state.interface';

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    formViewType: "default"
  } as ISettingsState,
  reducers: {
    updateSettings: (state, action: PayloadAction<ISettingsState>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { updateSettings } = settingsSlice.actions;
export default settingsSlice.reducer;